import { useGetLicenses } from "@/hooks/useGetLicenses/useGetLicenses";

import {
  FEATURE_LICENSES_MAPPING,
  FEATURE_NAME,
} from "./LicenseGuard.constant";

type UseHasLicenseAccessProps = {
  feature: FEATURE_NAME;
};

export function useHasLicenseAccess({
  feature,
}: UseHasLicenseAccessProps): boolean {
  const { licenses } = useGetLicenses();

  const requiredLicenses = FEATURE_LICENSES_MAPPING[feature];

  return requiredLicenses.some((license) =>
    licenses.some((l) => l.name === license && l.active)
  );
}
